module.exports = __webpack_public_path__ + "fbb01b01d439606e780e6e6564bba2b9.MP3";